import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
export function AssessmentTransitionPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const handleContinue = () => {
    const nextRoute = location.state?.nextRoute || '/assessment/self';
    navigate('/assessment/quiz', {
      state: {
        nextRoute
      }
    });
  };
  return <div className="w-full min-h-screen bg-[#f5f5f7] flex flex-col" data-id="element-658">
      {/* Top bar */}
      <div className="w-full px-5 pt-5 pb-3" data-id="element-659">
        <div className="max-w-md mx-auto flex items-center gap-4" data-id="element-660">
          <Link to="/assessment/goals" className="flex items-center justify-center w-10 h-10 -ml-2 text-gray-500 hover:text-[#631bb7] transition-colors" aria-label="Go back" data-id="element-661">
            <ArrowLeftIcon size={22} data-id="element-662" />
          </Link>
          {/* Progress bar */}
          <div className="flex-1 h-1.5 bg-gray-200 rounded-full overflow-hidden" data-id="element-663">
            <div className="h-full bg-[#631bb7] rounded-full transition-all duration-500" style={{
            width: '30%'
          }} data-id="element-664" />
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 px-6 pt-8 pb-10" data-id="element-665">
        <div className="max-w-md mx-auto text-center" data-id="element-666">
          <img src="https://cdn.magicpatterns.com/uploads/qm8eGpXKnKzyXLYb5H58w8/Caveo_Icon_Mark_48x39_Full_Color_PNG.png" alt="Caveo" className="w-16 h-auto mx-auto mb-6" data-id="element-667" />
          <h1 className="md:text-[30px] text-[26px] font-[600] text-[#190647] mb-4" data-id="element-668">
            Nice work!
          </h1>
          <p className="text-gray-500 text-base md:text-lg leading-relaxed mb-8" data-id="element-669">
            Having a good understanding of who you are and what your goals are
            will allow us to not only provide a valuable risk assessment, but
            show how you specifically can achieve your goals with Caveo.
          </p>
          <p className="text-gray-500 text-lg md:text-xl leading-relaxed" data-id="element-670">
            Now let's dive into the first topic area: <br data-id="element-671" />
            <span className="inline-flex items-center gap-1.5 mt-2 text-[#190647] font-[600]" data-id="element-672">
              🏠 Home Wi-Fi Network
            </span>
          </p>

          <button onClick={handleContinue} className="mt-10 w-full py-3.5 rounded-lg font-semibold text-white bg-[#631bb7] hover:bg-[#521099] transition-all shadow-md" data-id="element-673">
            Let's Continue
          </button>
        </div>
      </div>
    </div>;
}